import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { AuthFlowInput } from '../../interfaces/auth-flow-input.interface';
import { AuthFlowOutput } from '../../interfaces/auth-flow-output.interface';
import { AuthFlowOption } from '../../interfaces/auth-flow-option.interface';
import { FormsModule } from '@angular/forms';
import { DxTextBoxModule, DxNumberBoxModule } from 'devextreme-angular';
import { NgIf, NgFor, AsyncPipe } from '@angular/common';

@Component({
    selector: 'al-auth-flow-modal',
    templateUrl: './auth-flow-modal.component.html',
    styleUrls: ['./auth-flow-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        NgIf,
        NgFor,
        DxTextBoxModule,
        FormsModule,
        DxNumberBoxModule,
        AsyncPipe,
    ],
})
export class AuthFlowModalComponent {
	public showDialog$ = new BehaviorSubject<boolean>(false);
	result$: Subject<AuthFlowInput>;

	afOutput$: BehaviorSubject<AuthFlowOutput> = new BehaviorSubject<AuthFlowOutput>(undefined);

	constructor(private cdr: ChangeDetectorRef) {}

	public show(afOutput: AuthFlowOutput) {
		this.result$ = new Subject<AuthFlowInput>();

		this.showDialog$.next(true);
		this.afOutput$.next(afOutput);

		this.cdr.detectChanges();

		return this.result$.asObservable();
	}

	public selectOption(option: AuthFlowOption) {
		this.result$.next({
			selectedOption: option.name,
			argumentValues: option.arguments.map(a => a.value),
		});
		this.result$.complete();
		this.showDialog$.next(false);
	}

	public exit(): void {
		this.result$.next({
			selectedOption: 'Finish',
			argumentValues: [],
		});
		this.result$.complete();
		this.showDialog$.next(false);
	}

	separateWords(state: string) {
		return state.replace(/([A-Z])/g, ' $&');
	}
}
